import { styled } from '@mui/system';

export const StyledPanel = styled('div')`
  margin: 25px 10px 10px 10px;
  display: flex;
  width: 100%;
  alignitems: center;
`;
